/*
 * iCalendar constants
 * https://datatracker.ietf.org/doc/html/rfc5545
 */

export const DAY_OF_WEEK = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
};
// Map our day of week enum to RFC-5545 format
export const DAY_OF_WEEK_MAP = {
  [DAY_OF_WEEK.MONDAY]: 'MO',
  [DAY_OF_WEEK.TUESDAY]: 'TU',
  [DAY_OF_WEEK.WEDNESDAY]: 'WE',
  [DAY_OF_WEEK.THURSDAY]: 'TH',
  [DAY_OF_WEEK.FRIDAY]: 'FR',
  [DAY_OF_WEEK.SATURDAY]: 'SA',
  [DAY_OF_WEEK.SUNDAY]: 'SU'
};

// Reverse map for parsing
export const REVERSE_DAY_OF_WEEK_MAP = {
  MO: DAY_OF_WEEK.MONDAY,
  TU: DAY_OF_WEEK.TUESDAY,
  WE: DAY_OF_WEEK.WEDNESDAY,
  TH: DAY_OF_WEEK.THURSDAY,
  FR: DAY_OF_WEEK.FRIDAY,
  SA: DAY_OF_WEEK.SATURDAY,
  SU: DAY_OF_WEEK.SUNDAY
};
// Week of month options
export const WEEK_OF_MONTH = {
  FIRST: 'first',
  SECOND: 'second',
  THIRD: 'third',
  FOURTH: 'fourth',
  LAST: 'last'
};
// Map our relative week enum to RFC-5545 format
export const WEEK_OF_MONTH_MAP = {
  [WEEK_OF_MONTH.FIRST]: '1',
  [WEEK_OF_MONTH.SECOND]: '2',
  [WEEK_OF_MONTH.THIRD]: '3',
  [WEEK_OF_MONTH.FOURTH]: '4',
  [WEEK_OF_MONTH.LAST]: '-1'
};

// Reverse map for parsing
export const REVERSE_WEEK_OF_MONTH_MAP = {
  '1': WEEK_OF_MONTH.FIRST,
  '2': WEEK_OF_MONTH.SECOND,
  '3': WEEK_OF_MONTH.THIRD,
  '4': WEEK_OF_MONTH.FOURTH,
  '-1': WEEK_OF_MONTH.LAST
};
export const MONTH_OF_YEAR = {
  JANUARY: 'JANUARY',
  FEBRUARY: 'FEBRUARY',
  MARCH: 'MARCH',
  APRIL: 'APRIL',
  MAY: 'MAY',
  JUNE: 'JUNE',
  JULY: 'JULY',
  AUGUST: 'AUGUST',
  SEPTEMBER: 'SEPTEMBER',
  OCTOBER: 'OCTOBER',
  NOVEMBER: 'NOVEMBER',
  DECEMBER: 'DECEMBER'
};
export const MONTH_OF_YEAR_MAP = {
  [MONTH_OF_YEAR.JANUARY]: '1',
  [MONTH_OF_YEAR.FEBRUARY]: '2',
  [MONTH_OF_YEAR.MARCH]: '3',
  [MONTH_OF_YEAR.APRIL]: '4',
  [MONTH_OF_YEAR.MAY]: '5',
  [MONTH_OF_YEAR.JUNE]: '6',
  [MONTH_OF_YEAR.JULY]: '7',
  [MONTH_OF_YEAR.AUGUST]: '8',
  [MONTH_OF_YEAR.SEPTEMBER]: '9',
  [MONTH_OF_YEAR.OCTOBER]: '10',
  [MONTH_OF_YEAR.NOVEMBER]: '11',
  [MONTH_OF_YEAR.DECEMBER]: '12'
};
export const REVERSE_MONTH_OF_YEAR_MAP = {
  '1': MONTH_OF_YEAR.JANUARY,
  '2': MONTH_OF_YEAR.FEBRUARY,
  '3': MONTH_OF_YEAR.MARCH,
  '4': MONTH_OF_YEAR.APRIL,
  '5': MONTH_OF_YEAR.MAY,
  '6': MONTH_OF_YEAR.JUNE,
  '7': MONTH_OF_YEAR.JULY,
  '8': MONTH_OF_YEAR.AUGUST,
  '9': MONTH_OF_YEAR.SEPTEMBER,
  '10': MONTH_OF_YEAR.OCTOBER,
  '11': MONTH_OF_YEAR.NOVEMBER,
  '12': MONTH_OF_YEAR.DECEMBER
};
export const FREQUENCY = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY'
};

// Interface for BYDAY values that can include position prefixes

export const R_RULE_PROPERTY = {
  FREQ: 'FREQ',
  UNTIL: 'UNTIL',
  COUNT: 'COUNT',
  INTERVAL: 'INTERVAL',
  WEEK_START: 'WKST',
  BY_DAY: 'BYDAY',
  BY_MONTH: 'BYMONTH',
  BY_MONTH_DAY: 'BYMONTHDAY'
};
export const I_CALENDAR_PROPERTY = {
  RRULE: 'RRULE'
};
export const DAY_OF_WEEK_TRANSLATION_MAP = {
  [DAY_OF_WEEK.MONDAY]: 'meetings-icalendar-utils-lib.iCalendar.dayOfWeek.monday',
  [DAY_OF_WEEK.TUESDAY]: 'meetings-icalendar-utils-lib.iCalendar.dayOfWeek.tuesday',
  [DAY_OF_WEEK.WEDNESDAY]: 'meetings-icalendar-utils-lib.iCalendar.dayOfWeek.wednesday',
  [DAY_OF_WEEK.THURSDAY]: 'meetings-icalendar-utils-lib.iCalendar.dayOfWeek.thursday',
  [DAY_OF_WEEK.FRIDAY]: 'meetings-icalendar-utils-lib.iCalendar.dayOfWeek.friday',
  [DAY_OF_WEEK.SATURDAY]: 'meetings-icalendar-utils-lib.iCalendar.dayOfWeek.saturday',
  [DAY_OF_WEEK.SUNDAY]: 'meetings-icalendar-utils-lib.iCalendar.dayOfWeek.sunday'
};
export const WEEK_NUMBER_TRANSLATION_MAP = {
  '1': 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.first',
  '2': 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.second',
  '3': 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.third',
  '4': 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.fourth',
  '-1': 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.last'
};
export const WEEK_OF_MONTH_TRANSLATION_MAP = {
  [WEEK_OF_MONTH.FIRST]: 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.first',
  [WEEK_OF_MONTH.SECOND]: 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.second',
  [WEEK_OF_MONTH.THIRD]: 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.third',
  [WEEK_OF_MONTH.FOURTH]: 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.fourth',
  [WEEK_OF_MONTH.LAST]: 'meetings-icalendar-utils-lib.iCalendar.weekOfMonth.last'
};
export const MONTH_OF_YEAR_TRANSLATION_MAP = {
  [MONTH_OF_YEAR.JANUARY]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.january',
  [MONTH_OF_YEAR.FEBRUARY]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.february',
  [MONTH_OF_YEAR.MARCH]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.march',
  [MONTH_OF_YEAR.APRIL]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.april',
  [MONTH_OF_YEAR.MAY]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.may',
  [MONTH_OF_YEAR.JUNE]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.june',
  [MONTH_OF_YEAR.JULY]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.july',
  [MONTH_OF_YEAR.AUGUST]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.august',
  [MONTH_OF_YEAR.SEPTEMBER]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.september',
  [MONTH_OF_YEAR.OCTOBER]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.october',
  [MONTH_OF_YEAR.NOVEMBER]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.november',
  [MONTH_OF_YEAR.DECEMBER]: 'meetings-icalendar-utils-lib.iCalendar.monthOfYear.december'
};